import axios from "axios";
import router from "@/router";

/**
 * VWA device API of the project service. Used by VWA users, who only have
 * access to VWA sections and not to the general project endpoints.
 */
const VwaDevices = {
  createAxiosInstance() {
    const axiosProjects = axios.create({
      baseURL: process.env.VUE_APP_PROJECT,
      headers: {
        // @ts-ignore
        Authorization: "Bearer " + router.app.$keycloak.token,
        Accept: "application/json"
      }
    });
    return axiosProjects;
  },
  async GetAllVwaDevices() {
    const res = await this.createAxiosInstance().get(`/api/v1/vwa-devices`);
    return res;
  },
  async GetVwaSectionDetails(sectionId: number | string) {
    const res = await this.createAxiosInstance().get(`/api/v1/vwa-devices/${sectionId}`);
    return res;
  },
  async GetVwaSectionState(sectionId: number | string) {
    const res = await this.createAxiosInstance().get(`/api/v1/vwa-devices/${sectionId}/state`);
    return res;
  },
  async UpdateVwaImages(sectionId: number | string, settings: object) {
    const res = await this.createAxiosInstance().put(`/api/v1/vwa-devices/${sectionId}/settings`, settings);
    return res;
  }
};

export default VwaDevices;
